<template>
  <div>
    <section class="feature-area section-padding2 toubugaodu"
      style=" height: 400px; background: url('../static/assets/images/bannerc.jpg') no-repeat;background-size: 100% auto;">
      <div class="container">
        <div class="row toubugaoduzt" style="height: 400px; line-height: 400px;color: #ffffff;font-size: 45px;">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <p style=" font-style: initial; ">关于我们</p>
            </div>
          </div>
        </div>

      </div>
      <div class="about_tab">
        <router-link class="about_tab_jj" to="/about" @click.native="reloadPage">企业简介</router-link>
        <router-link class="about_tab_wh" to="/wenhua" @click.native="reloadPage">企业文化</router-link>
        <router-link class="about_tab_jg" to="/jiagou" @click.native="reloadPage">企业架构</router-link>
        <router-link class="about_tab_zr" to="/zeren" @click.native="reloadPage">认证体系</router-link>
        <router-link class="about_tab_sm" to="/shengming" @click.native="reloadPage"
          style="background: #0473db;color: #ffffff;">版权声明</router-link>
      </div>
    </section>


    <section class="feature-area section-padding2 shengming_section1">
      <div class="shengming_section1_one">
        <div class="shengming_section1_one_1">
          <div class="shengming_section1_one_2 animate fadeInLeft animated"
            style="animation-duration: 1s; animation-delay: 0.5s; visibility: visible;">
            <img src="/static/assets/images/banquan.jpg" />
          </div>
          <div class="shengming_section1_one_3">
            <img src="/static/assets/images/banquan01.jpg" class="animate zoomIn animated"
              style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;" />
            <div class="shengming_section1_one_4 animate fadeInUp animated"
              style="animation-duration: 0.5s; animation-delay: 1.5s; visibility: visible;">
              <img src="/static/assets/images/banquan02.jpg" />
            </div>
          </div>
        </div>
        <div class="  animate fadeInRight40 animated shengmingkuandu" style="width: 50%; float: right;font-size: 16px;">
          <p v-html="aboutinfo.content"></p>
        </div>


      </div>
    </section>
    <section class="feature-area section-padding2 shengming_section2 buxianshi">
      <div class="container" style="padding-top: 200px;">
        <a href="https://register.ccopyright.com.cn/query.html" target="_blank">
          <div class="index-banner">
            <div class="g_w1200">
              <div class="index-search">
                <div class="title">登记公告检索</div>
                <div data-v-7dec1380="" class="search">
                  <ul data-v-7dec1380="" class="tabs g_clearfix">
                    <li data-v-7dec1380="" class="current">查软件</li>
                    <li data-v-7dec1380="" class="">查作品</li>
                    <li data-v-7dec1380="" class="">查DCI</li>
                  </ul>

                  <ul data-v-7dec1380="">
                    <li data-v-7dec1380="">
                      <div data-v-7dec1380="" class="search_box g_clearfix">
                        <div data-v-7dec1380="" class="input_box">
                          <input data-v-7dec1380="" type="text" placeholder="请输入精准登记号" class="input_register">
                          <input data-v-7dec1380="" type="text" placeholder="请输入著作权人或软件名称" class="input_name">
                        </div>
                        <div data-v-7dec1380="" class="button"></div>
                      </div>
                      <ul data-v-7dec1380="" class="search_tips g_clearfix">
                        <li data-v-7dec1380="" class="title">例如：</li>
                        <li data-v-7dec1380="">2018SR13332 美图美化修图软件</li>
                      </ul>
                      <ul data-v-7dec1380="" class="search_subTips g_clearfix">
                        <li data-v-7dec1380="" class="title"></li>
                        <li data-v-7dec1380="">如需检索软件登记事项变更或补充登记，请输入登记号和变更后的著作权人或软件名称</li>
                      </ul>
                    </li>
                  </ul>

                  <!---->
                </div>
              </div>
            </div>
          </div>
        </a>


      </div>
    </section>
    <!-- Feature Area End -->




  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      aboutinfo: [],
      newurl: 'https://naduapi.jurenkeji.com.cn',
    };
  },
  mounted() {
    //公司信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/25', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        console.log(response.data.data);
        this.aboutinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
  },
  methods: {
    reloadPage() {
      // console.log('3333')
      // 如果不是因为导航重复而出现错误，则重新加载页面
      window.location.reload()
    },
    // 截取新闻标题字符串至指定长度
    truncatecontent(dateStr, length = 20) {
      return dateStr.substring(0, length);
    },


  }
};
</script>


// WEBPACK FOOTER //
// Shengming.vue?4382e3ec